var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgUserIcon = function SvgUserIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1021 7C15.1021 9.76142 12.8178 12 10 12C7.18221 12 4.89794 9.76142 4.89794 7C4.89794 4.23858 7.18221 2 10 2C12.8178 2 15.1021 4.23858 15.1021 7ZM14.0025 12.7986C15.8976 11.5399 17.1429 9.41247 17.1429 7C17.1429 3.13401 13.9449 0 10 0C6.05509 0 2.85712 3.13401 2.85712 7C2.85712 9.41247 4.10243 11.5399 5.99745 12.7986C2.95595 14.0709 0.673367 16.7491 0 20H2.09388C3.0001 16.5495 6.19623 14 10 14C13.8038 14 16.9999 16.5495 17.9061 20H20C19.3266 16.7491 17.044 14.0709 14.0025 12.7986Z",
    fill: "white"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUserIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/user-icon.59ec1536.svg";
export { ForwardRef as ReactComponent };